/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'xilo-mono-form-viewer-failure-modal',
  templateUrl: './failure-modal.component.html',
  styleUrls: ['./failure-modal.component.scss'],
})
export class FailureModalComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<FailureModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      description:string
    },
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.data.description =`${this.data.description === '' ? 
    "We couldn't find any information to make this faster for you. No worries, we can still continue! Please continue the form." : this.data.description}`;
    setTimeout(() => {
      this.closeDialog();
    }, 7500);
  }

  closeDialog() {
    this.dialogRef.close({ success: false });
  }
}
